// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"01afbbd6","326":"0075336e","488":"f28827a2","591":"8f240a86","680":"d24f969e","900":"b9e332b3"}[chunkId] + ".chunk.js";
};